var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "spare-part-kits" }, [
    _vm.notice
      ? _c("p", {
          staticClass: "spare-part-kits__notice",
          domProps: { innerHTML: _vm._s(_vm.notice) }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.pumpSeriesFacets.length > 0 ||
    _vm.pumpSizesFacets.length > 0 ||
    _vm.pumpDesignsFacets.length > 0
      ? _c("div", { staticClass: "filter-section" }, [
          _c("div", { staticClass: "filter-items" }, [
            _vm.pumpSeriesFacets.length > 0 && !_vm.preselectedPumpSeriesFacet
              ? _c("div", { staticClass: "filter-item filter-item--mw" }, [
                  _c(
                    "label",
                    {
                      staticClass: "sr-only",
                      attrs: { for: "pumpSeriesFilter" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.dictionaries.SparePartKitsPumpSeriesFacetDefault
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pumpSeries,
                          expression: "pumpSeries"
                        }
                      ],
                      staticClass: "filter-item__select",
                      attrs: {
                        id: "pumpSeriesFilter",
                        name: "pumpSeriesFilter",
                        disabled: _vm.isLoading
                      },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.pumpSeries = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "All" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.dictionaries.SparePartKitsPumpSeriesFacetDefault
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.pumpSeriesFacets, function(pumpSeries, index) {
                        return pumpSeries.Name
                          ? _c(
                              "option",
                              { domProps: { value: pumpSeries.Key } },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(pumpSeries.Name)
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pumpSizesFacets.length > 0 &&
            _vm.pumpSeries !== "All" &&
            !_vm.preselectedPumpSizeFacet
              ? _c("div", { staticClass: "filter-item filter-item--mw" }, [
                  _c(
                    "label",
                    {
                      staticClass: "sr-only",
                      attrs: { for: "pumpSizeFilter" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.dictionaries.SparePartKitsPumpSizeFacetDefault
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pumpSize,
                          expression: "pumpSize"
                        }
                      ],
                      staticClass: "filter-item__select",
                      attrs: {
                        id: "pumpSizeFilter",
                        name: "pumpSizeFilter",
                        disabled: _vm.isLoading
                      },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.pumpSize = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "All" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.dictionaries.SparePartKitsPumpSizeFacetDefault
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.pumpSizesFacets, function(pumpSize, index) {
                        return pumpSize.Name
                          ? _c(
                              "option",
                              { domProps: { value: pumpSize.Key } },
                              [_vm._v(_vm._s(pumpSize.Name))]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pumpDesignsFacets.length > 0 &&
            _vm.pumpSize != "All" &&
            !_vm.preselectedPumpDesignFacet
              ? _c("div", { staticClass: "filter-item filter-item--mw" }, [
                  _c(
                    "label",
                    {
                      staticClass: "sr-only",
                      attrs: { for: "pumpDesignFilter" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.dictionaries.SparePartKitsPumpDesignFacetDefault
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pumpDesign,
                          expression: "pumpDesign"
                        }
                      ],
                      staticClass: "filter-item__select",
                      attrs: {
                        id: "pumpDesignFilter",
                        name: "pumpDesignFilter",
                        disabled: _vm.isLoading
                      },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.pumpDesign = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "All" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.dictionaries.SparePartKitsPumpDesignFacetDefault
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.pumpDesignsFacets, function(
                        pumpDesign,
                        index
                      ) {
                        return pumpDesign.Name
                          ? _c(
                              "option",
                              { domProps: { value: pumpDesign.Key } },
                              [
                                _vm._v(
                                  _vm._s(pumpDesign.Name) +
                                    "\n                    "
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showResultSet && !_vm.hasPredefinedFacets
              ? _c("div", { staticClass: "filter-item" }, [
                  _c(
                    "button",
                    {
                      staticClass: "filter-item__button",
                      attrs: { type: "button", disabled: _vm.isLoading },
                      on: { click: _vm.resetFilter }
                    },
                    [_vm._v(_vm._s(_vm.dictionaries.SparePartKitsFilterReset))]
                  )
                ])
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.sparePartKits.length && _vm.showResultSet,
            expression: "sparePartKits.length && showResultSet"
          }
        ],
        staticClass: "spare-part-kits__list"
      },
      _vm._l(_vm.sparePartKits, function(sparePartKit) {
        return _c("SparePartKitItem", {
          key: sparePartKit.Id,
          attrs: {
            sparePartKit: sparePartKit,
            buttonText: _vm.dictionaries.SparePartKitsDownloadPdfButtonLabel
          }
        })
      }),
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showpreselectedSparePartKits,
            expression: "showpreselectedSparePartKits"
          }
        ],
        staticClass: "spare-part-kits__list"
      },
      _vm._l(_vm.preselectedSparePartKits, function(sparePartKit) {
        return _c("SparePartKitItem", {
          key: sparePartKit.Id,
          attrs: {
            sparePartKit: sparePartKit,
            buttonText: _vm.dictionaries.SparePartKitsDownloadPdfButtonLabel
          }
        })
      }),
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              !_vm.sparePartKits.length && !_vm.isLoading && _vm.showResultSet,
            expression: "!sparePartKits.length && !isLoading && showResultSet"
          }
        ],
        staticClass: "spare-part-kits__no-result"
      },
      [_vm._v("\n        " + _vm._s(_vm.dictionaries.SparePartKitsNoResult))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.hasMoreSparePartKitsToLoad && _vm.showResultSet,
            expression: "hasMoreSparePartKitsToLoad && showResultSet"
          }
        ],
        staticClass: "spare-part-kits__cta"
      },
      [
        _c(
          "a",
          {
            staticClass: "spare-part-kits__load-more",
            attrs: { disabled: _vm.isLoading },
            on: { click: _vm.getNextPage }
          },
          [_vm._v(_vm._s(_vm.dictionaries.SparePartKitsLoadMore))]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6993f7b2", { render: render, staticRenderFns: staticRenderFns })
  }
}